import React, { useState } from 'react';
import { View, StyleSheet, ScrollView, Alert } from 'react-native';
import { Text, TextInput, Button, Divider, HelperText, ActivityIndicator } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import api from '../../services/api';

const NuevoProveedorScreen = () => {
  const navigation = useNavigation();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    contacto: '',
    telefono: '',
    email: '',
    direccion: '',
    rtn: '',
    notas: ''
  });
  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: null });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.nombre.trim()) {
      newErrors.nombre = 'El nombre es obligatorio';
    }
    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Ingresa un email válido';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      await api.createProveedor(formData);
      Alert.alert('Éxito', 'Proveedor creado correctamente', [
        { text: 'OK', onPress: () => navigation.goBack() }
      ]);
    } catch (error) {
      console.error('Error al crear proveedor:', error);
      Alert.alert('Error', error.message || 'No se pudo crear el proveedor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <ScrollView style={styles.container}>
      <View style={styles.form}>
        <Text style={styles.sectionTitle}>Información del Proveedor</Text>

        <TextInput
          label="Nombre *"
          value={formData.nombre}
          onChangeText={(v) => handleChange('nombre', v)}
          style={styles.input}
          mode="outlined"
          error={!!errors.nombre}
        />
        {errors.nombre && <HelperText type="error">{errors.nombre}</HelperText>}

        <TextInput
          label="RTN"
          value={formData.rtn}
          onChangeText={(v) => handleChange('rtn', v)}
          style={styles.input}
          mode="outlined"
        />

        <TextInput
          label="Persona de contacto"
          value={formData.contacto}
          onChangeText={(v) => handleChange('contacto', v)}
          style={styles.input}
          mode="outlined"
        />

        <Divider style={styles.divider} />
        <Text style={styles.sectionTitle}>Datos de Contacto</Text>

        <TextInput
          label="Teléfono"
          value={formData.telefono}
          onChangeText={(v) => handleChange('telefono', v)}
          style={styles.input}
          mode="outlined"
          keyboardType="phone-pad"
        />

        <TextInput
          label="Email"
          value={formData.email}
          onChangeText={(v) => handleChange('email', v)}
          style={styles.input}
          mode="outlined"
          keyboardType="email-address"
          autoCapitalize="none"
          error={!!errors.email}
        />
        {errors.email && <HelperText type="error">{errors.email}</HelperText>}

        <TextInput
          label="Dirección"
          value={formData.direccion}
          onChangeText={(v) => handleChange('direccion', v)}
          style={styles.input}
          mode="outlined"
          multiline
          numberOfLines={2}
        />

        <Divider style={styles.divider} />
        <Text style={styles.sectionTitle}>Notas</Text>

        <TextInput
          label="Notas adicionales"
          value={formData.notas}
          onChangeText={(v) => handleChange('notas', v)}
          style={styles.input}
          mode="outlined"
          multiline
          numberOfLines={3}
        />

        <View style={styles.buttonContainer}>
          <Button
            mode="outlined"
            onPress={() => navigation.goBack()}
            style={styles.cancelButton}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            mode="contained"
            onPress={handleSubmit}
            style={styles.submitButton}
            loading={loading}
            disabled={loading}
          >
            Guardar
          </Button>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#f5f5f5' },
  form: { padding: 16 },
  sectionTitle: { fontSize: 16, fontWeight: 'bold', color: '#333', marginBottom: 8 },
  input: { marginBottom: 8, backgroundColor: '#fff' },
  divider: { marginVertical: 12 },
  buttonContainer: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 20, marginBottom: 40 },
  cancelButton: { flex: 1, marginRight: 8 },
  submitButton: { flex: 1, marginLeft: 8, backgroundColor: '#0066cc' },
});

export default NuevoProveedorScreen;
